import { UserInfo } from 'models/user';
import { getCurrentUser } from 'services/users';
import { CHURN_ZERO_EVENTS, CONSTANTS } from '../constants/common';

const userId = (id?: string) => {
  if (id) {
    localStorage.setItem('fnUserId', id);
  }
  return localStorage.getItem('fnUserId');
};

const currentCustomerCompanyId = (id?: string) => {
  if (id) {
    localStorage.setItem('fnCurrentCustomerCompanyId', id);
  }
  return localStorage.getItem('fnCurrentCustomerCompanyId');
};

const currentCustomerAccountId = (id?: string) => {
  if (id) {
    localStorage.setItem('fnCurrentCustomerAccountId', id);
  }
  return localStorage.getItem('fnCurrentCustomerAccountId');
};

const userRole = (role?: string) => {
  if (role) {
    localStorage.setItem('fnUserRole', role);
  }
  return localStorage.getItem('fnUserRole');
};

const userToken = (token?: string) => {
  if (token) {
    localStorage.setItem('fnUserToken', token);
  }
  return localStorage.getItem('fnUserToken');
};

const userPlan = (plan?: string) => {
  if (plan) {
    localStorage.setItem('fnUserPlan', plan);
  }
  return localStorage.getItem('fnUserPlan');
};

const userEmail = (email?: string) => {
  if (email) {
    localStorage.setItem('fnUserEmail', email);
  }
  return localStorage.getItem('fnUserEmail');
};
const userHubspotContactId = (hubspotContactId?: string) => {
  if (hubspotContactId) {
    localStorage.setItem('fnUserHubspotContactId', hubspotContactId);
  }
  return localStorage.getItem('fnUserHubspotContactId');
};

const auth0State = (state?: string) => {
  if (state) {
    localStorage.setItem('auth0State', state);
  }
  return localStorage.getItem('auth0State');
};

interface NameVariable {
  first?: string;
  last?: string;
  middle?: string;
}
const userName = (name?: NameVariable) => {
  if (name) {
    const { first, last } = name;
    localStorage.setItem('fnUserName', `${first} ${last}`);
  }
  return localStorage.getItem('fnUserName');
};

// cache T&C version
let fnUserLatestTnCVersion: string | undefined;

const userConsent = (lastTncAcceptedVersion?: string) => {
  if (lastTncAcceptedVersion) {
    fnUserLatestTnCVersion = lastTncAcceptedVersion;
  }
  return fnUserLatestTnCVersion;
};

const isAdmin = () =>
  (Object.values(CONSTANTS.USER_ROLES) as string[]).includes(userRole()!) &&
  userRole() !== CONSTANTS.USER_ROLES.CUSTOMER;

const isSuperAdmin = () => userRole() === CONSTANTS.USER_ROLES.SUPER_ADMIN;

const isCustomer = () => userRole() === CONSTANTS.USER_ROLES.CUSTOMER;

const clearAllData = (withoutToken = false) => {
  localStorage.removeItem('auth0State');
  localStorage.removeItem('fnUserPlan');
  localStorage.removeItem('fnUserEmail');
  localStorage.removeItem('fnUserRole');
  localStorage.removeItem('fnUserId');
  localStorage.removeItem('fnCurrentCustomerCompanyId');
  localStorage.removeItem('fnCurrentCustomerAccountId');
  localStorage.removeItem('fnUserLatestTnCVersion');
  localStorage.removeItem('fnUserHubspotContactId');
  localStorage.removeItem('sidebarOpen'); // create sidebar open setting
  fnUserLatestTnCVersion = undefined;
  if (!withoutToken) {
    localStorage.removeItem('fnUserToken');
  }
};

const refresh = async () => {
  const userData = await getCurrentUser();
  const { id, email, role, name, lastTncAcceptedVersion } = userData || {};
  userId(id);
  userEmail(email);
  userRole(role);
  userName(name);
  userConsent(lastTncAcceptedVersion);
  return true;
};

const updateCurrentUser = (userData: UserInfo) => {
  const { id, email, role, name, lastTncAcceptedVersion } = userData || {};
  userId(id);
  userEmail(email);
  userRole(role);
  userName(name);
  userConsent(lastTncAcceptedVersion);
};

export const AuthService = {
  auth0State,
  userId,
  userPlan,
  userEmail,
  refresh,
  userName,
  userConsent,
  userHubspotContactId,

  // new methods for data refactoring
  isAdmin,
  isSuperAdmin,
  isCustomer,
  userToken,
  currentCustomerAccountId,
  currentCustomerCompanyId,
  clearAllData,
  updateCurrentUser,
  userRole,
};

/** clear data after logout */
const clearChurnZeroLoginEventStore = () => {
  localStorage.removeItem(CHURN_ZERO_EVENTS.LOGIN);
};

const clearAllAuthData = () => {
  AuthService.clearAllData();
};

const pipe = (...functions: Array<() => void>) =>
  functions.forEach((fn) => {
    try {
      fn();
    } catch (e) {
      console.error(e);
    }
  });

export const clearDataWhenLogOut = () => {
  pipe(clearAllAuthData, clearChurnZeroLoginEventStore);
};

export const resetDataBeforeAuth = () => {
  pipe(clearChurnZeroLoginEventStore);
};
